module.exports = __webpack_public_path__ + "img/more-offers-img.7a20b6b9.png";